/// <reference path="../../../typings/tsd.d.ts" /> 

module warsApp.directives {
    export interface IManageSectionScope extends ng.IScope {
        manageSection: Wars.Domain.Model.ManageSection;
        isConfigureMode: boolean;
        isEditMode: boolean;
        save: any;
        deleteSection: any;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        processConfigurationId: string;
        forms: Wars.Domain.Model.Form[];
        formId: string;
        editSecurityMatrix: any;
        userActionInitiated: (u: any) => any;
        hideSection: any;
        groupDeleteConfirmation: any;
        deleteGroupClicked(): void;
    }

    export class ManageSection implements IDirective {
        public link($scope: IFieldSectionScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = './app/views/directives/manageForm/manageSection.html';
        public controller = ['$scope', 'formService', 'deleteService', 'securityMatrixService','$rootScope', ManageSectionController];
        public controllerAs = 'controller';
        public restrict: string = 'E';
        public scope: any = {
            isConfigureMode: "=",
            isEditMode: "=",
            manageSection: "=",
            process: "=",
            processConfigurationId: "=",
            processConfiguration: "=",
            formDataId: "=",
            formId: "="
        };
    }

    export class ManageSectionController {
        constructor(private scope: IManageSectionScope,
            private formService: services.FormService,
            private deleteService: services.DeleteService,
            private securityMatrixService: services.SecurityMatrixService,
            private $rootScope: angular.IRootScopeService)
        {
            scope.save = () => this.save();
            scope.editSecurityMatrix = () => this.editSecurityMatrix();
            scope.deleteSection = (ms) => this.deleteSection(ms);
            scope.userActionInitiated = (u) => this.userActionInitiated(u);
            scope.hideSection =
            {
                hideSection: false
            };

            if (scope.manageSection.manageSectionType === Wars.Domain.Model.Codes.Enums.ManageSectionType.EmbeddedForm) {
                this.formService.getProcessConfigurationForms(this.scope.processConfigurationId)
                    .then(f => {
                        scope.forms = f;
                    });
            }

            this.loadEmbeddedForm();

            this.scope.groupDeleteConfirmation =
            {
                show: false
            }
            this.scope.deleteGroupClicked = () => this.deleteGroupClicked();
        }

        private deleteGroupClicked() {
            this.scope.groupDeleteConfirmation.show = true;
        }

        private deleteSection(section: Wars.Domain.Model.ManageSection) {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "ManageSection",
                section.id,
                "Manage Section");
        }

        private editSecurityMatrix() {
            this.securityMatrixService.openSecurityMatrixModal(this.scope.manageSection.securityMatrix,this.scope.processConfigurationId);
        }

        private loadEmbeddedForm() {
            if (this.scope.manageSection.manageSectionType ===
                Wars.Domain.Model.Codes.Enums.ManageSectionType.EmbeddedForm &&
                this.scope.manageSection.embeddedForm != null) {
                this.formService.getFormConfiguration(this.scope.manageSection.embeddedForm.id)
                    .then(f => {
                        this.scope.manageSection.embeddedForm = f;
                    });
            }
        }

        

        public save() {
            this.loadEmbeddedForm();
            this.formService.saveAllChanges();
        }

        userActionInitiated(userAction: Wars.Domain.Model.Dtos.UserActionModelDto) {
            this.$rootScope.$broadcast('userActionInitated', userAction);
        }
    }
}

warsApp.registerDirective('ManageSection', []);